export default "__VITE_ASSET__33b0e1a7__"